import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { guestModeSelector } from "../../state/selectors/userModel";
import { userModelSelector } from "../../state/selectors/userModel";
import { useRecoilState } from "recoil";

export default function CheckGuestMode() {
    const location = useLocation();
    const [guestMode, setGuestMode] = useRecoilState(guestModeSelector);
    const [userModel, setUserModel] = useRecoilState(userModelSelector);

    useEffect(() => {
        if (!location.pathname || !userModel) return;

        if (
            location.pathname.includes("/profile") ||
            location.pathname.includes("/edit-profile") ||
            location.pathname.includes("/security-settings") ||
            location.pathname.includes("/payout-settings") ||
            location.pathname.includes("/payment-settings") ||
            location.pathname.includes("/refer") ||
            location.pathname.includes("/host/profile") ||
            location.pathname.includes("/guest/profile")
        )
            return;
        if (
            location.pathname.includes("/listings") ||
            location.pathname.includes("/calendar") ||
            location.pathname.includes("/create-listing") ||
            location.pathname.includes("/stay") ||
            location.pathname.includes("/invoice") ||
            location.pathname.includes("/review-guest") ||
            location.pathname.includes("/inbox-lite") ||
            location.pathname.includes("/inbox") ||
            location.pathname.includes("/edit-listing") ||
            location.pathname.includes("/edit-extra") ||
            location.pathname.includes("/dashboard") ||
            location.pathname.includes("/all-bookings") ||
            location.pathname.includes("/payouts") ||
            location.pathname.includes("/insights") ||
            location.pathname.includes("/payout/") ||
            location.pathname.includes("/invite") ||
            location.pathname.includes("/tools") ||
            location.pathname.includes("/extras")
        ) {
            setGuestMode(false);
            return;
        }
        setGuestMode(true);
        //don't use userModel in dependency, will cause inifinite rerender
    }, [location, setGuestMode, userModel?.guestMode]);

    return <></>;
}
